// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"296":"efda4d9b","826":"cd675f36"}[chunkId] + ".chunk.css";
};